import React from "react";
import { TabelaDeCotacaoConcurso } from "./index";

export default function ConcursosCotacoes({ tipoCotacoes, nomeJogo }) {
  return (
    <div class="container-cotacoes">
      <h1>Premiações!</h1>
      <h2>Quanto posso ganhar?</h2>
      <p>
        Na <strong className="capitalize">{nomeJogo}</strong>, a premiação é
        baseada na quantidade de dezenas que foram selecionadas, e no valor
        apostado. Desta forma, quanto maior o valor apostado e menor for a
        quantidade de dezenas escolhidas, maior será sua premiação!
      </p>
      <p>
        <strong>Segue cotação baseado em R$: 1,00.</strong>
      </p>

      <TabelaDeCotacaoConcurso acertosValor={tipoCotacoes.acertosValor} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/newDesign/components/cotacoes/concursos.jsx